"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicProfileDtoShiftTimePreferencesEnum = void 0;
exports.instanceOfPublicProfileDto = instanceOfPublicProfileDto;
exports.PublicProfileDtoFromJSON = PublicProfileDtoFromJSON;
exports.PublicProfileDtoFromJSONTyped = PublicProfileDtoFromJSONTyped;
exports.PublicProfileDtoToJSON = PublicProfileDtoToJSON;
exports.PublicProfileDtoToJSONTyped = PublicProfileDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const InfectiousDiseaseTestDto_1 = require("./InfectiousDiseaseTestDto");
const FileDto_1 = require("./FileDto");
const FitTestDto_1 = require("./FitTestDto");
const NurseLicenseDto_1 = require("./NurseLicenseDto");
const RegulatoryAssessmentAbbrDto_1 = require("./RegulatoryAssessmentAbbrDto");
const StoredDocumentDto_1 = require("./StoredDocumentDto");
const VaccinationDto_1 = require("./VaccinationDto");
const DhsBackgroundCheckStatusDto_1 = require("./DhsBackgroundCheckStatusDto");
const ShiftRequestPublicAbbrDto_1 = require("./ShiftRequestPublicAbbrDto");
const TuberculosisScreeningDto_1 = require("./TuberculosisScreeningDto");
const CertificationDto_1 = require("./CertificationDto");
const PublicBackgroundCheckDto_1 = require("./PublicBackgroundCheckDto");
const FacilityProfileDocumentDto_1 = require("./FacilityProfileDocumentDto");
const OrientationDocumentDto_1 = require("./OrientationDocumentDto");
const ElectronicMedicalRecordSystemDto_1 = require("./ElectronicMedicalRecordSystemDto");
const LocationDto_1 = require("./LocationDto");
/**
 * @export
 */
exports.PublicProfileDtoShiftTimePreferencesEnum = {
    Days06001830: 'DAYS_0600_1830',
    Days07001100: 'DAYS_0700_1100',
    Days07001530: 'DAYS_0700_1530',
    Days07001930: 'DAYS_0700_1930',
    Days11001500: 'DAYS_1100_1500',
    Eves15001900: 'EVES_1500_1900',
    Eves15002330: 'EVES_1500_2330',
    Eves19002300: 'EVES_1900_2300',
    Nights03000700: 'NIGHTS_0300_0700',
    Nights18000630: 'NIGHTS_1800_0630',
    Nights19000730: 'NIGHTS_1900_0730',
    Nights23000300: 'NIGHTS_2300_0300',
    Nights23000730: 'NIGHTS_2300_0730',
    Custom: 'CUSTOM'
};
/**
 * Check if a given object implements the PublicProfileDto interface.
 */
function instanceOfPublicProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('verifiedFacilities' in value) || value['verifiedFacilities'] === undefined)
        return false;
    if (!('professionalSummary' in value) || value['professionalSummary'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    if (!('location' in value) || value['location'] === undefined)
        return false;
    if (!('specialties' in value) || value['specialties'] === undefined)
        return false;
    if (!('regulatoryAssessments' in value) || value['regulatoryAssessments'] === undefined)
        return false;
    if (!('licenses' in value) || value['licenses'] === undefined)
        return false;
    if (!('certifications' in value) || value['certifications'] === undefined)
        return false;
    if (!('vaccinations' in value) || value['vaccinations'] === undefined)
        return false;
    if (!('infectiousDiseaseTests' in value) || value['infectiousDiseaseTests'] === undefined)
        return false;
    if (!('tuberculosisScreening' in value) || value['tuberculosisScreening'] === undefined)
        return false;
    if (!('shiftRequests' in value) || value['shiftRequests'] === undefined)
        return false;
    if (!('orientationDocuments' in value) || value['orientationDocuments'] === undefined)
        return false;
    if (!('dhsBackgroundCheck' in value) || value['dhsBackgroundCheck'] === undefined)
        return false;
    if (!('dhsDocuments' in value) || value['dhsDocuments'] === undefined)
        return false;
    if (!('backgroundChecks' in value) || value['backgroundChecks'] === undefined)
        return false;
    if (!('electronicMedicalRecordSystems' in value) || value['electronicMedicalRecordSystems'] === undefined)
        return false;
    if (!('fitTest' in value) || value['fitTest'] === undefined)
        return false;
    if (!('blockedFacilities' in value) || value['blockedFacilities'] === undefined)
        return false;
    if (!('resume' in value) || value['resume'] === undefined)
        return false;
    if (!('facilityProfileDocuments' in value) || value['facilityProfileDocuments'] === undefined)
        return false;
    if (!('maximumTravelDistanceMiles' in value) || value['maximumTravelDistanceMiles'] === undefined)
        return false;
    if (!('shiftTimePreferences' in value) || value['shiftTimePreferences'] === undefined)
        return false;
    return true;
}
function PublicProfileDtoFromJSON(json) {
    return PublicProfileDtoFromJSONTyped(json, false);
}
function PublicProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'verifiedFacilities': json['verifiedFacilities'],
        'professionalSummary': json['professionalSummary'],
        'avatar': json['avatar'],
        'phoneNumber': json['phoneNumber'],
        'location': (0, LocationDto_1.LocationDtoFromJSON)(json['location']),
        'specialties': (json['specialties'].map(SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)),
        'regulatoryAssessments': (json['regulatoryAssessments'].map(RegulatoryAssessmentAbbrDto_1.RegulatoryAssessmentAbbrDtoFromJSON)),
        'licenses': (json['licenses'].map(NurseLicenseDto_1.NurseLicenseDtoFromJSON)),
        'certifications': (json['certifications'].map(CertificationDto_1.CertificationDtoFromJSON)),
        'vaccinations': (json['vaccinations'].map(VaccinationDto_1.VaccinationDtoFromJSON)),
        'infectiousDiseaseTests': (json['infectiousDiseaseTests'].map(InfectiousDiseaseTestDto_1.InfectiousDiseaseTestDtoFromJSON)),
        'tuberculosisScreening': (0, TuberculosisScreeningDto_1.TuberculosisScreeningDtoFromJSON)(json['tuberculosisScreening']),
        'shiftRequests': (json['shiftRequests'].map(ShiftRequestPublicAbbrDto_1.ShiftRequestPublicAbbrDtoFromJSON)),
        'orientationDocuments': (json['orientationDocuments'].map(OrientationDocumentDto_1.OrientationDocumentDtoFromJSON)),
        'dhsBackgroundCheck': (0, DhsBackgroundCheckStatusDto_1.DhsBackgroundCheckStatusDtoFromJSON)(json['dhsBackgroundCheck']),
        'dhsDocuments': (json['dhsDocuments'] == null ? null : json['dhsDocuments'].map(StoredDocumentDto_1.StoredDocumentDtoFromJSON)),
        'backgroundChecks': (json['backgroundChecks'].map(PublicBackgroundCheckDto_1.PublicBackgroundCheckDtoFromJSON)),
        'electronicMedicalRecordSystems': (json['electronicMedicalRecordSystems'].map(ElectronicMedicalRecordSystemDto_1.ElectronicMedicalRecordSystemDtoFromJSON)),
        'fitTest': (0, FitTestDto_1.FitTestDtoFromJSON)(json['fitTest']),
        'blockedFacilities': json['blockedFacilities'],
        'resume': (0, FileDto_1.FileDtoFromJSON)(json['resume']),
        'facilityProfileDocuments': (json['facilityProfileDocuments'].map(FacilityProfileDocumentDto_1.FacilityProfileDocumentDtoFromJSON)),
        'maximumTravelDistanceMiles': json['maximumTravelDistanceMiles'],
        'shiftTimePreferences': json['shiftTimePreferences'],
    };
}
function PublicProfileDtoToJSON(json) {
    return PublicProfileDtoToJSONTyped(json, false);
}
function PublicProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'verifiedFacilities': value['verifiedFacilities'],
        'professionalSummary': value['professionalSummary'],
        'avatar': value['avatar'],
        'phoneNumber': value['phoneNumber'],
        'location': (0, LocationDto_1.LocationDtoToJSON)(value['location']),
        'specialties': (value['specialties'].map(SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)),
        'regulatoryAssessments': (value['regulatoryAssessments'].map(RegulatoryAssessmentAbbrDto_1.RegulatoryAssessmentAbbrDtoToJSON)),
        'licenses': (value['licenses'].map(NurseLicenseDto_1.NurseLicenseDtoToJSON)),
        'certifications': (value['certifications'].map(CertificationDto_1.CertificationDtoToJSON)),
        'vaccinations': (value['vaccinations'].map(VaccinationDto_1.VaccinationDtoToJSON)),
        'infectiousDiseaseTests': (value['infectiousDiseaseTests'].map(InfectiousDiseaseTestDto_1.InfectiousDiseaseTestDtoToJSON)),
        'tuberculosisScreening': (0, TuberculosisScreeningDto_1.TuberculosisScreeningDtoToJSON)(value['tuberculosisScreening']),
        'shiftRequests': (value['shiftRequests'].map(ShiftRequestPublicAbbrDto_1.ShiftRequestPublicAbbrDtoToJSON)),
        'orientationDocuments': (value['orientationDocuments'].map(OrientationDocumentDto_1.OrientationDocumentDtoToJSON)),
        'dhsBackgroundCheck': (0, DhsBackgroundCheckStatusDto_1.DhsBackgroundCheckStatusDtoToJSON)(value['dhsBackgroundCheck']),
        'dhsDocuments': (value['dhsDocuments'] == null ? null : value['dhsDocuments'].map(StoredDocumentDto_1.StoredDocumentDtoToJSON)),
        'backgroundChecks': (value['backgroundChecks'].map(PublicBackgroundCheckDto_1.PublicBackgroundCheckDtoToJSON)),
        'electronicMedicalRecordSystems': (value['electronicMedicalRecordSystems'].map(ElectronicMedicalRecordSystemDto_1.ElectronicMedicalRecordSystemDtoToJSON)),
        'fitTest': (0, FitTestDto_1.FitTestDtoToJSON)(value['fitTest']),
        'blockedFacilities': value['blockedFacilities'],
        'resume': (0, FileDto_1.FileDtoToJSON)(value['resume']),
        'facilityProfileDocuments': (value['facilityProfileDocuments'].map(FacilityProfileDocumentDto_1.FacilityProfileDocumentDtoToJSON)),
        'maximumTravelDistanceMiles': value['maximumTravelDistanceMiles'],
        'shiftTimePreferences': value['shiftTimePreferences'],
    };
}
//# sourceMappingURL=PublicProfileDto.js.map